// extracted by mini-css-extract-plugin
export default {"summary":"XG","separator":"YG","title":"ZG","note":"aH","items_wrapper":"bH","member_perk":"cH","info":"eH","extraQuestionsContain":"fH","h1":"gH","p":"hH","btn":"iH","stickyButton":"jH"};
    if(module.hot) {
      // 1737143662017
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  